import { Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Button } from 'shared';
import { userDataSelector } from 'store/slices/user-slice';
import RootModalLayout from '../RootModalLayout';
import classes from '../SharedModal.module.scss';

interface UserInformationMissingModalProps {
  isModalOpen?: boolean;
  onClose?: () => void;
}

export const UserInformationMissingModal: React.FC<UserInformationMissingModalProps> = ({ isModalOpen, onClose }) => {
  const navigate = useNavigate();
  const user = useSelector(userDataSelector);

  const [internalOpen, setInternalOpen] = useState(false);

  const open = isModalOpen !== undefined ? isModalOpen : internalOpen;

  useEffect(() => {
    if (isModalOpen !== undefined) return;

    if (!user) {
      setInternalOpen(false);
      return;
    }

    if (!user.isFullInfoProvided) {
      setInternalOpen(true);
    } else {
      setInternalOpen(false);
    }
  }, [user, isModalOpen]);

  const handleClose = () => {
    if (onClose) {
      onClose();
    } else {
      setInternalOpen(false);
    }
  };

  const navigateToPools = () => {
    navigate('/profile-settings');
    handleClose();
  };

  if (!open) return null;

  return (
    <RootModalLayout onClose={handleClose} title='We are missing some infos about you!'>
      <section className={classes.mainContent}>
        <Typography>
          To top up money to your balance or purchase a miner, you need to provide your personal information
        </Typography>
      </section>

      <section className={classes.modalFooter}>
        <Button variant='contained' onClick={navigateToPools}>
          Implement Information
        </Button>
      </section>
    </RootModalLayout>
  );
};
